module.exports = __webpack_public_path__ + "img/tabbar3.2f860553.svg";